function _getListAsOptions(options, innerOptionsKey, ignoreLabels) {
  options.forEach((option) => {
    if (!ignoreLabels) {
      option.isLabel = (option.is_label === true);
    }
    delete option.is_label;
    option.text = option.name;
    delete option.name;
    option.value = option.value || option.id;

    if (!innerOptionsKey || !option[innerOptionsKey]) {
      option.options = [];
      return;
    }
    option.options = _getListAsOptions(option[innerOptionsKey], innerOptionsKey, ignoreLabels);
    delete option[innerOptionsKey];
  });

  return options;
}

function _setOptionsHrefWithBaseUrl(options, baseUrl) {
  if (!options || !options.length) {
    return;
  }

  options.forEach((option) => {
    if (!option.slug) {
      option.href = baseUrl;
    } else {
      option.href = `${ baseUrl }/${ option.slug }`;
    }

    _setOptionsHrefWithBaseUrl(option.options, baseUrl);
  });
}

export default class DropdownOptionsHelper {
  static getBooksListAsOptions(books, sortAlphabetically = false) {
    if (!books) {
      throw new Error('books is required.');
    }

    books.forEach((book) => {
      book.isLabel = false;
      book.text = book.title;
      book.value = book.slug;
    });

    if (!sortAlphabetically) {
      return books;
    }

    return books.sort((a, b) => (a.title > b.title) ? 1 : -1);
  }

  static getListAsOptions(options, innerOptionsKey, ignoreLabels = false) {
    if (!options) {
      throw new Error('options is required.');
    }

    return _getListAsOptions(options, innerOptionsKey, ignoreLabels);
  }

  static getOptionsListFromStrings(options) {
    if (!options) {
      throw new Error('options is required.');
    }

    const optionsList = [];
    options.forEach((option) => {
      optionsList.push({
        isLabel: false,
        text: option,
        value: option,
      });
    });

    return optionsList;
  }

  static getNonRootOptions(options) {
    if (!options) {
      throw new Error('options is required.');
    }

    let nonRootOptions = [];
    options.forEach((option) => {
      if (!option.options) {
        return;
      }

      nonRootOptions = nonRootOptions.concat(option.options);
    });

    return nonRootOptions;
  }

  static getTwoLevelOptionsListFromStrings(options) {
    if (!options) {
      throw new Error('options is required.');
    }

    const firstLevel = DropdownOptionsHelper.getOptionsListFromStrings(Object.keys(options));

    const secondLevel = {};
    Object.keys(options).forEach((parentReason) => {
      secondLevel[parentReason] = DropdownOptionsHelper.getOptionsListFromStrings(options[parentReason]);
    });

    const twoLevelOptions = {
      firstLevel: firstLevel,
      secondLevel: secondLevel,
    };

    return twoLevelOptions;
  }

  static setOptionsHrefWithBaseUrl(options, baseUrl) {
    _setOptionsHrefWithBaseUrl(options, baseUrl);
  }
}
